import { create } from 'zustand';

import { parsePlanLimitError, type PlanLimitPayload } from '@/utils/parse-plan-limit-error';

interface PlanLimitState {
  payload: PlanLimitPayload | null;
  close: () => void;
}

/** Aviso de upgrade único, montado no layout raiz (`PlanLimitModal`). */
export const usePlanLimitStore = create<PlanLimitState>((set) => ({
  payload: null,
  close: () => set({ payload: null }),
}));

/**
 * Abre o aviso quando o erro é a trava do plano. Devolve `true` para o call
 * site pular o próprio toast — um feedback só.
 */
export function showPlanLimit(err: unknown): boolean {
  const payload = parsePlanLimitError(err);
  if (!payload) return false;
  usePlanLimitStore.setState({ payload });
  return true;
}
